

import { API_BASE_URL } from "@buzzwaretech/constants";
import { APIService } from "../api.service";

export default class IntakeIssueService extends APIService {
  constructor(BASE_URL?: string) {
    super(BASE_URL || API_BASE_URL);
  }

  async list(workspaceSlug: string, projectId: string, params = {}) {
    return this.get(
      `/api/workspaces/${workspaceSlug}/projects/${projectId}/inbox-issues/`,
      {
        params,
      },
    )
      .then((response) => response?.data)
      .catch((error) => {
        throw error?.response?.data;
      });
  }
}

export { IntakeIssueService };

